import ProdutosLista from "@/pages/produtos/ProdutosLista";
import ProdutosForm from "@/pages/produtos/ProdutosForm";
import ProdutosHistorico from "@/pages/produtos/ProdutosHistorico";

import EstoqueLista from "@/pages/estoque/EstoqueLista";
import EstoqueForm from "@/pages/estoque/EstoqueForm";

import BalancoLista from "@/pages/produtos/BalancoLista";

export default [
  {
    path: "/catalogo/produtos",
    name: "ProdutosLista",
    component: () => import(/* webpackChunkName: "produtoslista" */ '@/pages/produtos/ProdutosLista.vue'),
  },
  {
    path: "/catalogo/produtos/adicionar",
    name: "ProdutosAdicionar",
    component: ProdutosForm,
  },
  {
    path: "/catalogo/produtos/:id/editar",
    name: "ProdutosEditar",
    component: ProdutosForm,
    meta: { editando: true },
  },

  {
    path: "/catalogo/produtos/:id/historico",
    name: "ProdutosHistorico",
    component: ProdutosHistorico,
  },

  {
    path: "/catalogo/movimentoestoque",
    name: "EstoqueLista",
    component: EstoqueLista,
  },
  {
    path: "/catalogo/movimentoestoque/adicionar",
    name: "EstoqueAdicionar",
    component: EstoqueForm,
    meta: { modo: "adicionando" },
  },
  {
    path: "/catalogo/movimentoestoque/:id/editar",
    name: "EstoqueEditar",
    component: EstoqueForm,
    meta: { modo: "editando" },
  },
  {
    path: "/catalogo/movimentoestoque/:id/visualizar",
    name: "EstoqueVisualizar",
    component: EstoqueForm,
    meta: { modo: "visualizando" },
  },

  {
    path: "/catalogo/balanco/",
    name: "BalancoLista",
    component: BalancoLista
  },

  {
    path: "/catalogo/controleprodutos",
    name: "ControleProdutos",
    component: () => import(/* webpackChunkName: "controleprodutos" */ '@/pages/produtos/controle/ControleProdutos.vue'),
  },
  {
    path: "/catalogo/etiquetas",
    name: "EtiquetasProdutos",
    component: () => import(/* webpackChunkName: "etiquetaprodutos" */ '@/pages/produtos/etiquetas/EtiquetasProdutos.vue'),
  },
];
